import React from 'react'
import { StudentInfoCard } from '../StudentManagement'

const StudentInfoForProfile = ({ studentId, handlePrint, isProfile = false, isPrint = false }) => {
	if (isPrint) {
		// Compact print version
		return (
			<div className="print-student-info p-3">
				<StudentInfoCard studentId={studentId} isProfile={isProfile} />
			</div>
		)
	}

	// Screen version with print button
	return (
		<>
			<div className="d-flex gap-2 justify-content-end p-3">
				<button onClick={handlePrint} className="btn btn-info btn-sm">
					<i className="fa fa-print me-2"></i>
					Print Page
				</button>
			</div>
			<div className="card-body bg-white p-0">
				<StudentInfoCard studentId={studentId} isProfile={isProfile} />
			</div>
		</>
	)
}

export { StudentInfoForProfile }
